import createAction, {ReducerActionInterface} from "../../../lib/reducer.utils";
import {RootReducerState} from "../../root-reducer";
import {PostModel} from "../../../models/post.model";

/* Action types */
export const PostActionTypes = {
    CLEAR_CONTENT: "post/CLEAR_CONTENT",
    INIT: "post/INIT",
    SET_VALUE: "SET_VALUE"
}

const INITIAL_STATE: PostModel = {
    content: "", date: new Date().toISOString(), id: 0, preview: "", slugTitle: "", title: ""
}

export const postReducer = (state = INITIAL_STATE, action: ReducerActionInterface) => {
    const {type, payload} = action;

    switch (type) {
        case PostActionTypes.INIT:
            return {
                ...state,
                ...payload,
                isModified: false
            }

        case PostActionTypes.SET_VALUE:
            return {
                ...state,
                [payload.key]: payload.value
            }

        case PostActionTypes.CLEAR_CONTENT:
            return INITIAL_STATE;

        default:
            return state;
    }
}

/* Actions */
export const initPost = (payload: PostModel) => createAction({
    type: PostActionTypes.INIT,
    payload
})

export const clearPostContent = () => createAction({
    type: PostActionTypes.CLEAR_CONTENT
})

export const setPostValue = (key: any, value: any) => createAction({
    type: PostActionTypes.SET_VALUE,
    payload: {
        key,
        value
    }
})

/* Selectors */
export const getPostData = (state: RootReducerState) => state.post;